import React, { Component } from 'react';
import PagoManualIcon from '@mui/icons-material/MailOutline';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Collapse,
  Box,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  AttachMoney as AttachMoneyIcon
} from '@mui/icons-material';

const session = require('../../config/session');

class SaldoCajerosTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registros: [],
      filaExpandida: null
    };
  }

  handleExpand = (index) => {
    const yaExpandida = this.state.filaExpandida === index;
    if (yaExpandida) {
      this.setState({ filaExpandida: null });
    } else {
      this.setState({ filaExpandida: index });
    }
  }
  

  calcularArqueoPorDetalle = (detalle) => {
    const arqueoMap = {
      automatico: new Map(),
      manual: 0 // solo sumamos el total de sobres
    };

    try {
      if (!detalle || !detalle.detalle) {
        console.warn("Sin detalle");
        return { automatico: [], manual: 0 };
      }

      // Convertimos el string JSON a un array válido (ya que puede venir concatenado)
      const arrayDetalle = `[${detalle.detalle}]`;
      const parsedDetalles = JSON.parse(arrayDetalle);

      parsedDetalles.forEach((contenido) => {
        Object.entries(contenido).forEach(([tipo, seccion]) => {
          if (tipo === "automatico" && seccion?.currencies) {
            // Desglose de billetes automáticos
            seccion.currencies.forEach((currency) => {
              currency.bills.forEach((bill) => {
                const denom = bill.denomination;
                const cantidad = bill.amount;
                const fam = String(bill.familia || '');   // A = vieja, B = nueva (CA10)
                const cur = arqueoMap.automatico.get(denom) || { cantidad: 0, vieja: 0, nueva: 0 };
                cur.cantidad += cantidad;
                if (fam === 'A') cur.vieja += cantidad;
                else if (fam === 'B') cur.nueva += cantidad;
                arqueoMap.automatico.set(denom, cur);
              });
            });
          }

          // Si es manual, solo sumamos el total
          if (tipo === "manual" && seccion?.currencies) {
            seccion.currencies.forEach((currency) => {
              arqueoMap.manual += currency.total_bills || 0;
            });
          }
        });
      });
    } catch (e) {
      console.error("Error parseando el detalle:", e, detalle.detalle);
    }

    // Convertir el map de automático en array
    const arqueoAutomatico = Array.from(arqueoMap.automatico.entries())
      .sort((a, b) => b[0] - a[0])
      .map(([denominacion, v]) => ({
        denominacion,
        cantidad: v.cantidad,
        vieja: v.vieja,
        nueva: v.nueva,
        subtotal: denominacion * v.cantidad
      }));

    return {
      automatico: arqueoAutomatico,
      manual: arqueoMap.manual
    };
  };


  render(){
    const registros = this.props.registros;
    const { filaExpandida} = this.state;

    const columns = [
      { field: "desplegable", headerName: "", width: 70 },
      { field: "codigo_cajero", headerName: 'Codigo cajero', width: 180 },
      { field: "total_automatico", headerName: 'Total automatico', width: 180 },
      { field: "total_manual", headerName: 'Total sobres', width: 180 },
      { field: "alias_cajero", headerName: 'Alias cajero', width: 150 },
      { field: "pais", headerName: 'Pais', width: 200 },
      { field: "ciudad", headerName: 'Ciudad', width: 70, align: 'right' },
      { field: "saldo_actual", headerName: 'Total', width: 120, align: 'right' }
    ];

    
    return(
          <Paper elevation={3} sx={{ 
            width: '100%', 
            maxWidth: 980,
            overflow: 'hidden', 
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            mb: 3
          }}>
            <TableContainer>
              <Table stickyHeader sx={{ minWidth: 750 }}>
                <TableHead>
                  <TableRow sx={{
                    '& th': {                  
                      backgroundColor: '#8CC63E',
                      borderBottom: '2px solid #d2e8b5',
                      color: 'primary.contrastText',
                      fontWeight: 'fontWeightBold',
                      fontSize: '0.8rem',
                      py: 1.5,
                      px: 2
                    }
                  }}>
                    {columns.map((column) => (
                      <TableCell
                        key={column.field}
                        sx={{
                          width: column.width,
                          textAlign: column.align || 'left',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {column.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
      
                <TableBody>
                  {registros.map((registro, index) => {
                    const estaAbierta = filaExpandida === index;
                    
                    return (
                      <React.Fragment key={index}>
                        <TableRow sx={{
                          '&:hover': { backgroundColor: 'action.hover' },
                          '& td': { 
                            py: 1.5,
                            px: 2,
                            /* borderBottom: estaAbierta ? 'none' : undefined */
                          }
                        }}>
                          <TableCell>
                            <IconButton 
                              size="small" 
                              onClick={() => this.handleExpand(index)}
                              color={estaAbierta ? 'primary' : 'default'}
                            >
                              {estaAbierta ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            {registro.codigo_cajero}               
                          </TableCell>
                          <TableCell>{registro.total_automatico}</TableCell>
                          <TableCell>{registro.total_manual}</TableCell>
                          <TableCell>{registro.alias_cajero}</TableCell>
                          <TableCell>{registro.pais}</TableCell>
                          <TableCell>{registro.ciudad}</TableCell>
                          <TableCell sx={{ 
                            fontWeight: 'fontWeightMedium',
                            textAlign: 'right',
                            color: 'success.main'
                          }}>
                            {registro.saldo_actual.toLocaleString()}
                          </TableCell>
                        </TableRow>
      
                        <TableRow>
                          <TableCell colSpan={9} sx={{ 
                            p: 0,
                            borderBottom: `1px solid`,
                            borderColor: 'divider'
                          }}>
                            <Collapse in={estaAbierta} timeout="auto" unmountOnExit>
                              {estaAbierta && (() => {
                                const arqueo = this.calcularArqueoPorDetalle(registro);
                              

                                return (
                                  <Box sx={{ 
                                    backgroundColor: 'background.default',
                                    borderLeft: 4,
                                    borderColor: 'primary.main',
                                    p: 3
                                  }}>
                                   {/* Sección Arqueo */}
                                    <Box mt={4}>
                                      {/* --- Información de sobres (manual) --- */}
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <PagoManualIcon color="primary" sx={{ mr: 1 }} />
                                        <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                          Información de sobres
                                        </Typography>
                                      </Box>
                                      <Divider sx={{ mb: 2 }} />

                                      {arqueo.manual > 0 ? (
                                        <Box mt={2} mb={5} ml={5}>
                                          <Typography sx={{ mt: 1, fontWeight: "bold" }}>
                                            Dinero total en sobres: ${arqueo.manual.toLocaleString()}
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <Box mt={2} mb={5} ml={5}>
                                          <Typography color="text.secondary" fontStyle="italic">
                                            No hay sobres registrados.
                                          </Typography>
                                        </Box>
                                      )}

                                      {/* --- Desglose Automático --- */}
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                                        <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                          Desglose de Efectivo
                                        </Typography>
                                      </Box>
                                      <Divider sx={{ mb: 2 }} />

                                      {arqueo.automatico.length > 0 ? (
                                        <Box mb={4}>
                                          <Typography variant="subtitle1" fontWeight="fontWeightBold" sx={{ mb: 1 }}>
                                            Automático
                                          </Typography>
                                          <Table
                                            size="small"
                                            sx={{
                                              "& th": { backgroundColor: "action.selected", fontWeight: "bold" },
                                              "& td, & th": { py: 1, px: 2 },
                                            }}
                                          >
                                            <TableHead>
                                              <TableRow>
                                                <TableCell sx={{ width: 100 }}>Denominación</TableCell>
                                                <TableCell sx={{ textAlign: "right" }}>Cantidad</TableCell>
                                                <TableCell sx={{ textAlign: "right" }}>F. Vieja</TableCell>
                                                <TableCell sx={{ textAlign: "right" }}>F. Nueva</TableCell>
                                                <TableCell sx={{ textAlign: "right" }}>Subtotal</TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {arqueo.automatico.map((row, idx) => (
                                                <TableRow key={idx} hover>
                                                  <TableCell>{row.denominacion.toLocaleString()}</TableCell>
                                                  <TableCell sx={{ textAlign: "right" }}>{row.cantidad}</TableCell>
                                                  <TableCell sx={{ textAlign: "right" }}>{row.vieja || 0}</TableCell>
                                                  <TableCell sx={{ textAlign: "right" }}>{row.nueva || 0}</TableCell>
                                                  <TableCell sx={{ textAlign: "right", fontWeight: "500" }}>
                                                    ${row.subtotal.toLocaleString()}
                                                  </TableCell>
                                                </TableRow>
                                              ))}
                                            </TableBody>
                                            <TableFooter>
                                              <TableRow
                                                sx={{
                                                  "& td": {
                                                    fontWeight: "bold",
                                                    backgroundColor: "action.selected",
                                                  },
                                                }}
                                              >
                                                <TableCell>Total</TableCell>
                                                <TableCell />
                                                <TableCell sx={{ textAlign: "right" }}>
                                                  {arqueo.automatico.reduce((sum, r) => sum + (r.vieja || 0), 0)}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "right" }}>
                                                  {arqueo.automatico.reduce((sum, r) => sum + (r.nueva || 0), 0)}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "right" }}>
                                                  $
                                                  {arqueo.automatico
                                                    .reduce((sum, r) => sum + r.subtotal, 0)
                                                    .toLocaleString()}
                                                </TableCell>
                                              </TableRow>
                                            </TableFooter>
                                          </Table>
                                        </Box>
                                      ) : (
                                        <Typography color="text.secondary" fontStyle="italic" ml={5}>
                                          No hay registros automáticos.
                                        </Typography>
                                      )}
                                    </Box>

                                  </Box>
                                );
                              })()}
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        );
  }
}

export default SaldoCajerosTable


